import { render } from "./LoginHome.vue?vue&type=template&id=6e80b224&scoped=true"
import script from "./LoginHome.vue?vue&type=script&lang=js"
export * from "./LoginHome.vue?vue&type=script&lang=js"

import "./LoginHome.vue?vue&type=style&index=0&id=6e80b224&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e80b224"]])

export default __exports__